/**
 * quick-link.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import {
  Component,
  OnDestroy,
  OnInit
} from "@angular/core";

import { IntakeStepService }
  from "app/algorithms/management/intake-step.service";
import { IntakeStep } from "app/algorithms/structure";
import { Subscription } from "rxjs";

/**
 * The `QuickLinkComponent` presents a list of steps
 */
@Component({
  selector: "quick-links",
  template: `
    <!--<label *ngIf="links.length > 0"></label>-->
    <div class="btn-group">
      <button
        class="btn btn-sm btn-default"
        *ngFor="let link of links"
        (click)="scrollTo(link)">
        Jump to {{link.hints.quicklink || link.displayName || link.name}}
      </button>
    </div>
`,
  styles: [
    ``
  ]
})
export class QuickLinkComponent implements OnDestroy, OnInit
{
  public links : IntakeStep[] = [];

  private sub : Subscription;

  /**
   * Construct a new {@link SearchComponent}.
   *
   */
  public constructor (
    public steps : IntakeStepService
  )
  {
    //
  }

  public ngOnInit () : void
  {
    this.sub = this.steps.updatingSet().debounceTime(300)
      .subscribe((steps : IntakeStep[]) => {
        this.links = steps.filter(
          (s : IntakeStep) => s.hints && s.hints.quicklink);
      });
  }

  public ngOnDestroy () : void
  {
    this.sub.unsubscribe();
  }

  public scrollTo (link : IntakeStep) : void
  {
    if (link.hints.table && Array.isArray(link.value))
    {
      const id : string = `${link.id}:${(link.value as any[]).length - 1}`;
      const e : HTMLElement = document.getElementById(id);
      if (e)
      {
        e.scrollIntoView(
          {behavior: "smooth", block: "center", inline: "nearest"});
        // console.info(`FOUND ${id}`);
        return;
      }
    }

    const e : HTMLElement = document.getElementById(`${link.id}`);
    if (e)
    {
      e.scrollIntoView(
        {behavior: "smooth", block: "center", inline: "nearest"});
    }
    else
    {
      console.warn(
        `Could not find step matching id ${typeof link.id} ${link.id}`);
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/quick-link.component.ts